<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">
            Exact Match Rules
          </div>
          <div class="header-subtitle">
            Exact Match Rules are applied when a State ID is submitted with the record in the Assignment Process.  These rules do not apply to searches.
          </div>
        </template>
      </EsHeader>
      <div class="icon-right">
        <button
        class="button button-link"  
        :class="{ disabled: editOtherPanels }"
          @click="addPanel()"
          v-if="hasModule('SYS:SYS:RULEMGR:ADD')"
          :disabled="editOtherPanels"
        >
          <font-awesome-icon :icon="['far', 'plus']" size="lg" title="Add" />
        </button>
      </div>
    </div>
    <div class="content" style="padding : 0.5rem !important">
      <es-loader
        v-if="this.exactMatchRules.length === 0"
        style="margin: 5rem"
      />
      <table
        v-else
        v-for="eachPersonType in sortedAvailablePersonTypes"
        :key="eachPersonType.id"
      >
        <tbody>
          <tr>
            <th class="category" colspan="5" scope="colgroup">
              {{ eachPersonType.name }} Match Rules
            </th>
          </tr>
          <tr>
            <th class="rule" scope="col" title="Rule Name">
              Rule Name
            </th>
            <th class="rule" scope="col" title="Source(s)">
              Source(s)
            </th>
            <th class="rule" scope="col" title="Field(s)">
              Field(s)
            </th>
            <th class="rule" scope="col" title="Status">
              Status
            </th>
            <th class="rule" scope="col" title="Actions">
              Actions
            </th>
          </tr>
          <tr
            v-for="eachRule in ((exactMatchRules
              .map(k => k.filter(e => e.personType === eachPersonType.code)))
                .filter(x => x.length))
                .flat()"
            :key="eachRule.id"
          >
            <th class="th-normal" scope="row">
              {{ eachRule.ruleName }}
            </th>
            <td>
              <div class="tags">
                <strong
                  class="tag source-tag"
                  v-for="(source, index) in (JSON.parse(eachRule.sourcesJson).sources)"
                  :key="index"
                >
                  {{ source }}
                </strong>
              </div>
            </td>
            <td>
              {{ (JSON.parse(eachRule.matchFieldsJson).fields).length }}
            </td>
            <td>
              {{ eachRule.enable === true ? 'Enabled' : 'Disabled' }}
            </td>
            <td class="align-right">
              <button
                class="button button-link"
                @click="viewDetails(eachRule.id)"
              >
                <font-awesome-icon
                  :icon="['far', 'angle-double-right']"
                  class="fa-2x"
                  title="View Details"
                />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
  faPlus,
} from '@fortawesome/pro-regular-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleRight,
  faPlus,
);

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    EsHeader,
    EsLoader,
  },
  props: {
    editOtherPanels: {
      type: Boolean,
    },
    exactMatchRules: {
      type: Array,
    },
    sortedAvailablePersonTypes: {
      type: Array,
    },
  },
  methods: {
    addPanel() {
      this.$emit('allowEditOtherPanels');
      this.$emit('toggleAddExactMatchRule');
    },
    viewDetails(ruleId) {
      this.$emit('toggleExactMatchRuleDetails', ruleId);
    },
  },
};
</script>

<style lang="sass" scoped>
  table td
    vertical-align: middle
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
  .category
    padding-top: 1.5rem
  .header
    display: flex
    align-items: center
  .icon-right
    padding-right: 1rem
  .align-right
    text-align: right !important
    width: 1%
    white-space: nowrap
  .rule
    font-size: 12px
    color: #666
  .name
    width: 300px
  .th-normal
    font-weight: 400
    vertical-align: middle
    overflow-wrap: break-word
    max-width: 280px
</style>
